/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { FC, useEffect } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useRemovePaymentMethodMutation } from 'api/billing'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
type RemovePaymentMethodLightboxProps = {
    id: string,
    status: boolean,
    close: () => void
}

export const RemovePaymentMethodLightbox: FC<RemovePaymentMethodLightboxProps> = ({ status, close, id }) => {
    /*   QUERIES & MUTATIONS
    **********************************************************************************************************/
    const [removePaymentMethod, { isLoading: removePaymentMethodLoading, isSuccess: removePaymentMethodSuccess }] = useRemovePaymentMethodMutation()

    /*   EFFECTS
**********************************************************************************************************/
    useEffect(() => {
        if (removePaymentMethodSuccess) close()
    }, [removePaymentMethodSuccess])

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            id={'warning'}
            type={'confirm'}
            icon={'warning'}
            title={'Remove Payment Method'}
            description={'Are you sure you want to remove this payment method?'}
            conditions={{ state: status, action: () => close() }}
            close={close}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Remove',
                    color: 'error',
                    loading: removePaymentMethodLoading,
                    disabled: removePaymentMethodLoading,
                    func: () => removePaymentMethod(id)
                }
            ]}
        />
    )
}
